import { Watch } from 'vue-property-decorator';
import { BaseView } from '@shared/views/BaseView';
import { PersonBase } from '@shared/models';
import moment from 'moment';

export class PersonDetailsView<T extends PersonBase> extends BaseView {

	public model: T;
	public age: number = null;
	public born: string = null;
	public died: string = null;

	/** Calculates dates to determine age */
	@Watch('model', { immediate: true, deep: true })
	public calculateDates() {
		let lastDay = new Date();
		if (this.model.deathYear && this.model.deathMonth && this.model.deathDay) {
			const death = moment(`${this.model.deathYear}-${this.model.deathMonth.toString().padStart(2, '0')}-${this.model.deathDay.toString().padStart(2, '0')}`);
			this.died = death.format('MMMM DD, YYYY');
			lastDay = death.toDate();
		}
		if (this.model.birthYear && this.model.birthMonth && this.model.birthDay) {
			const birth = moment(`${this.model.birthYear}-${this.model.birthMonth.toString().padStart(2, '0')}-${this.model.birthDay.toString().padStart(2, '0')}`);
			this.born = birth.format('MMMM DD, YYYY');
			const last = moment(lastDay);
			this.age = last.diff(birth, 'years');
		}
	}

}
